/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Col,
} from 'react-bootstrap';
import RichButton from 'loracoms/RichButton';
import FormBlock from 'loracoms/FormBlock';
import ControlTips from 'loracoms/ControlTips';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import deviceActions from 'loraactions/device';
import { isInteger } from 'lorautils/checkers/numbers';


const propTypes = {
  sent: React.PropTypes.object.isRequired,
  intl: React.PropTypes.any.isRequired,
  deviceId: React.PropTypes.string.isRequired,
  sendCmd: React.PropTypes.func.isRequired,
  getTxSize: React.PropTypes.func.isRequired,
  getMacLog: React.PropTypes.func.isRequired,
};

class DutyCycleReq extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: new ErrorSet().add('FE_EMPTY', 'maxdc'),
    };
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.macview');
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeMaxdc = this.handleChangeMaxdc.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { sent } = nextProps;
    let { errors } = this.state;

    if (sent !== this.props.sent) {
      this.setState({ sentStatus: sent.status });
      if (sent.status === 'failure') {
        errors = errors.add(sent.error.code, 'submit');
        this.setState({ errors });
      }
      if (sent.status === 'success') {
        const { getTxSize, getMacLog, deviceId } = nextProps;
        getTxSize(deviceId);
        getMacLog(deviceId);
      }
    }
  }

  handleChangeMaxdc(e) {
    const maxdc = e.target.value.trim();
    this.setState({ maxdc });

    const { errors } = this.state;

    if (maxdc === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'maxdc') });
      return;
    }
    if (!isInteger(maxdc, { min: 0, max: 15 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'maxdc') });
      return;
    }
    this.setState({ errors: errors.remove('maxdc') });
  }

  handleSubmit(e) {
    this.setState({ submitted: true });
    e.preventDefault();

    const { errors } = this.state;
    if (!errors.isEmpty()) {
      return;
    }

    const { deviceId, sendCmd } = this.props;
    const { maxdc } = this.state;
    sendCmd(deviceId, { maxdc });
  }

  render() {
    const {
      sentStatus = '',
      maxdc = '',
      errors,
      submitted = false,
    } = this.state;

    return (
      <Form horizontal onSubmit={this.handleSubmit}>
        <FormGroup validationState={submitted && errors.has('maxdc') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">MaxDutyCycle</ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={maxdc}
              placeholder={this.intlMsg.msg('dutycyclereq.maxdc.placeholder')}
              onChange={this.handleChangeMaxdc}
            />
            <ControlTips
              show={submitted && errors.has('maxdc')}
              message={this.intlMsg.errorMsg(errors.get('maxdc'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={3} md={6}>
            <RichButton
              status={sentStatus}
              states={[{
                status: 'default',
                label: this.intlMsg.msg('submit'),
                style: 'primary',
                type: 'submit',
              }, {
                status: 'success',
                label: this.intlMsg.msg('submit.success'),
                style: 'success',
                timer: () => this.setState({ sentStatus: '' }),
              }, {
                status: 'failure',
                label: this.intlMsg.msg('submit.failure'),
                style: 'danger',
                timer: () => this.setState({ sentStatus: '' }),
              }]}
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={3} md={6}>
            <FormBlock
              show={errors.has('submit')}
              message={this.intlMsg.errorMsg(errors.get('submit'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
      </Form>
    );
  }
}

DutyCycleReq.propTypes = propTypes;

const mapStateToProps = state => ({
  sent: state.device.sendDutyCycleReq,
});

const mapDispatchToProps = {
  sendCmd: deviceActions.sendDutyCycleReq,
  getTxSize: deviceActions.getMacTxSize,
  getMacLog: deviceActions.getMacLog,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(DutyCycleReq));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/MacView/coms/DutyCycleReq.jsx